<template>
  <section class="department">
    <div class="title">
      <picture v-if="imagephoto">
        <source :srcset="imagephoto"
                media="(min-width: 768px)">
        <source :srcset="imagephotoSp"
                media="(max-width: 767px)">
        <img :src="imagephoto" />
      </picture>
      <h4 class="department-title">
        <img :src="titlephoto" alt="titlealt">
      </h4>
    </div>
    <div class="text">
      <slot>
      </slot>
    </div>
  </section>
</template>

<script>
export default {
  name: 'workCat',
  props: {
    imagephoto: {
      type: String,
      default: '',
    },
    imagephotoSp: {
      type: String,
      default: ''
    },
    titlephoto: {
      type: String,
      default: ''
    },
    titlealt: {
      type: String,
      default: ''
    },
  }
}
</script>

<style lang="scss" scoped>
.department {
  max-width: 1000px;
  width: 100%;
  margin: 0 auto;
  margin-top: 100px;
  @media print,screen and (max-width: 768px) {
    margin-top: 50px;
  }
}
.title {
  position: relative;
  min-height: 70px;
}
.department-title {
  background-color: #3fae00;
  display: inline-block;
  margin-bottom: 0;
  margin-top: -70px;
  position: absolute;
  bottom: -20px;
  left: 0;
  margin: 0;
  @media print,screen and (min-width: 1101px) {
    margin-left: 50px;
    padding: 20px 30px;
    height: 30px;
  }
  @media print,screen and (max-width: 1100px) {
    margin-left: -5%;
    padding: 1em 5%;
    height: 20px;
  }
  img {
    // width: 100%;
    height: 30px;
    vertical-align: baseline;
    @media print,screen and (max-width: 1100px) {
      height: 20px;
    }
  }
}
</style>
